import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { SearchSelect } from '@fortem-monorepo/react-ui'

import { CONTRACT_TYPE_OPTIONS } from '@/pages/instruments/new-instrument/constants/contract-types'

export interface ContractTypeCellEditorProps extends CustomCellEditorProps {}

export const ContractTypeCellEditor: React.FC<ContractTypeCellEditorProps> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)

  return (
    <div className={'flex items-center h-full!'}>
      <SearchSelect
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        open={open}
        setOpen={setOpen}
        setValue={(val) => {
          onValueChange(val !== null ? val : null)
          stopEditing()
        }}
        value={value?.toString()}
        options={CONTRACT_TYPE_OPTIONS}
      />
    </div>
  )
}
